// extracted by mini-css-extract-plugin
export default {"anttagcheckable":"Sender_anttagcheckable__Lfftc","rightText":"Sender_rightText__pQuaJ","link":"Sender_link__ShJmI"};